import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة العملات - تحويل الأرقام إلى نصوص عربية";
const DESCRIPTION =
  "احسب قيمة مبلغ معين بعملتك المفضلة كرقم وكلمة عربية. تساعدك هذه الحاسبة في معرفة كيفية كتابة المبلغ بالأرقام والكلمات.";
const KEYWORDS = "حاسبة, عملات, تحويل, أرقام, نصوص, ريال, جنيه, درهم";
const OG_URL = "https://do-calculate.com/calculator/ar/currency-spreader/";
function numberToArabicText(num) {
  const ones = [
    "",
    "واحد",
    "اثنان",
    "ثلاثة",
    "أربعة",
    "خمسة",
    "ستة",
    "سبعة",
    "ثمانية",
    "تسعة",
  ];
  const teens = [
    "عشرة",
    "أحد عشر",
    "اثنا عشر",
    "ثلاثة عشر",
    "أربعة عشر",
    "خمسة عشر",
    "ستة عشر",
    "سبعة عشر",
    "ثمانية عشر",
    "تسعة عشر",
  ];
  const tens = [
    "",
    "عشرة",
    "عشرون",
    "ثلاثون",
    "أربعون",
    "خمسون",
    "ستون",
    "سبعون",
    "ثمانون",
    "تسعون",
  ];
  const hundreds = [
    "",
    "مائة",
    "مئتان",
    "ثلاثمائة",
    "أربعمائة",
    "خمسمائة",
    "ستمائة",
    "سبعمائة",
    "ثمانمائة",
    "تسعمائة",
  ];
  let str = "";
  if (num >= 100) {
    str += hundreds[Math.floor(num / 100)] + " ";
    num %= 100;
  }
  if (num >= 20) {
    str += tens[Math.floor(num / 10)] + " ";
    num %= 10;
  }
  if (num >= 10 && num < 20) {
    str += teens[num - 10] + " ";
    num = 0;
  }
  if (num > 0) {
    if (str !== "") {
      str += "و ";
    }
    str += ones[num] + " ";
  }
  return str.trim();
}
function CurrencyConverter() {
  const [amount, setAmount] = useState("0");
  const [currency, setCurrency] = useState("ريال سعودي");
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [error, setError] = useState("");
  const calculateConvertedAmount = () => {
    try {
      if (amount === "0") {
        setError("الرجاء إدخال مبلغ من أجل التحويل");
        return;
      }
      const arabicText = numberToArabicText(Number(amount));
      const conversion = `${arabicText} ${currency}`;
      setConvertedAmount(conversion);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  توفر هذه الحاسبة وسيلة بسيطة لتحويل الأرقام إلى نصوص عربية
                  وإرفاقها بالعملة المطلوبة. يمكنك بسهولة معرفة كيفية كتابة
                  المبلغ بالأرقام والكلمات في آن واحد.
                </p>
                <p>
                  على سبيل المثال، إذا كان لديك مبلغ 500 ريال سعودي، ستقوم
                  الحاسبة بتحويل الرقم إلى نص عربي "خمسمئة ريال سعودي". هذه
                  المعلومات مفيدة في العديد من التطبيقات مثل كتابة الشيكات أو
                  العقود.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="amount">المبلغ:</label>
                    <input
                      id="amount"
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="currency">العملة:</label>
                    <select
                      id="currency"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    >
                      <option value="ريال سعودي">ريال سعودي</option>
                      <option value="ريال قطري">ريال قطري</option>
                      <option value="جنيه مصري">جنيه مصري</option>
                      <option value="جنيه سوداني">جنيه سوداني</option>
                      <option value="درهم إماراتي">درهم إماراتي</option>
                      <option value="درهم مغربي">درهم مغربي</option>
                      <option value="دينار كويتي">دينار كويتي</option>
                      <option value="دينار أردني">دينار أردني</option>
                      <option value="دينار جزائري">دينار جزائري</option>
                      <option value="دينار بحريني">دينار بحريني</option>
                      <option value="دينار تونسي">دينار تونسي</option>
                      <option value="دينار عراقي">دينار عراقي</option>
                      <option value="ليرة سورية">ليرة سورية</option>
                      <option value="ليرة لبنانية">ليرة لبنانية</option>
                    </select>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateConvertedAmount}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  convertedAmount !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>المبلغ المحول: {convertedAmount}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية تحويل الأرقام إلى نصوص</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: تحديد المبلغ المراد تحويله
                    </h2>
                  </u>
                  <p>
                    في البداية، يجب عليك معرفة المبلغ الذي ترغب في تحويله من
                    أرقام إلى نصوص. تأكد من إدخال المبلغ الصحيح في المكان
                    المخصص.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: اختيار العملة
                    </h2>
                  </u>
                  <p>
                    بعد تحديد المبلغ، اختر العملة التي ترغب في إرفاقها بالمبلغ
                    النصي. اختر من بين العملات العربية المتاحة.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: تحويل الرقم إلى نص
                    </h2>
                  </u>
                  <p>
                    الآن وبعد إدخال المبلغ واختيار العملة، ستقوم الحاسبة بتحويل
                    الرقم إلى نص عربي وإرفاق العملة المحددة. على سبيل المثال،
                    المبلغ 500 سيتم تحويله إلى "خمسمئة".
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: 500 ريال سعودي = خمسمئة ريال سعودي.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: التأكد من الحسابات
                    </h2>
                  </u>
                  <p>
                    بعد إجراء التحويل، تأكد من أن النص المتولد يتوافق مع الرقم
                    الذي أدخلته. هذه الخطوة مهمة لضمان الدقة في الكتابة.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    تذكر: التأكد دائمًا من القيم المدخلة والنص المتولد لضمان
                    الدقة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default CurrencyConverter;
